export default {
  '': '',
  'Sign in': 'Sign in',
  'Phone Login': 'Phone Login',
  'Email Login': 'Email Login',
  'I have read and agree to the': 'I have read and agree to the',
  'Privacy Policy': 'Privacy Policy',
  and: 'and',
  'Terms of Use': 'Terms of Use',
  Login: 'Login',
  'Mobile number': 'Mobile number',
  'Verification code': 'Verification code',
  'Email address': 'Email address',
  'Please enter a valid phone number!': 'Please enter a valid phone number!',
  'Please enter a valid email address!': 'Please enter a valid email address!',
  'Please enter your phone number!': 'Please enter your phone number!',
  'Please enter your email address!': 'Please enter your email address!',
  'Please enter the verification code!': 'Please enter the verification code!',
  'Please accept the privacy policy and user agreement!': 'Please accept the privacy policy and user agreement!',
  'Incorrect verification code, please check the code!': 'Incorrect verification code, please check the code!',
  'The verification code has expired, please retrieve a new one!': 'The verification code has expired, please retrieve a new one!',
  'The verification code has been used, please retrieve a new one!': 'The verification code has been used, please retrieve a new one!',
  'Login failed, please try again.': 'Login failed, please try again.',
  SEND: 'SEND',
  ' ': ' ',
  'The room does not exist, please confirm the room number or create a room!': 'The room does not exist, please confirm the room number or create a room!',
  'Log out': 'Log out',
  'Edit profile': 'Edit profile',
  'User Name': 'User Name',
  'Please input user name': 'Please input user name',
  'Username length should be greater than 0': 'Username length should be greater than 0',
  Save: 'Save',
  Camera: 'Camera',
  Mic: 'Mic',
  'Off Camera': 'Off Camera',
  'Mic settings': 'Mic settings',
  Output: 'Output',
  Speaker: 'Speaker',
  Test: 'Test',
  Stop: 'Stop',
  Preview: 'Preview',
  Mirror: 'Mirror',
  Resolution: 'Resolution',
  'More Camera Settings': 'More Camera Settings',
  'Join the room ?': 'Join the room ?',
  'You are invited to room ': 'You are invited to room ',
  Room: 'Room',
  Join: 'Join',
  Sure: 'Sure',
  'Switch Theme': 'Switch Theme',
  Layout: 'Layout',
  'New Room': 'New Room',
  'Room Type': 'Room Type',
  'Your Name': 'Your Name',
  'Grid view': 'Grid view',
  'Speaker view': 'Speaker view',
  'Turn on the microphone': 'Turn on the microphone',
  'Turn on the speaker': 'Turn on the speaker',
  'Turn on the video': 'Turn on the video',
  'Free Speech Room': 'Free Speech Room',
  'On-stage Speaking Room': 'On-stage Speaking Room',
  'Join Room': 'Join Room',
  'Enter room ID': 'Enter room ID',
  'video conferencing': ' \'s video conferencing',
  'Quick Meeting': ' \'s Quick Meeting',
  'Room ID': 'Room ID',
  'Low Definition': 'Low Definition',
  'Standard Definition': 'Standard Definition',
  'High Definition': 'High Definition',
  'Super Definition': 'Super Definition',
  'End sharing': 'End sharing',
  'Stop sharing?': 'Stop sharing?',
  'Stop sharing': 'Stop sharing',
  'You are sharing the screen...': 'You are sharing the screen...',
  Sharing: 'Sharing',
  'Safety Reminder': 'Safety Reminder',
  'Share screen': 'Share screen',
  'Grant permission to screen recording': 'Grant permission to screen recording',
  'Open the system preferences settings': 'Open the system preferences settings',
  'Due to macOS 10.15 system requirements, please check the current application in "System Preferences - Security & Privacy - Screen Recording".': 'Due to macOS 10.15 system requirements, please check the current application in "System Preferences - Security & Privacy - Screen Recording".',
  'Others will no longer see your screen after you stop sharing. Are you sure you want to stop?': 'Others will no longer see your screen after you stop sharing. Are you sure you want to stop?',
  'Others will no longer see your screen after you stop sharing.': 'Others will no longer see your screen after you stop sharing.',
  'You currently do not have sharing permission, please raise your hand to apply for sharing permission first': 'You currently do not have sharing permission, please raise your hand to apply for sharing permission first',
  Host: 'Host',
  Admin: 'Admin',
  RoomOwner: 'RoomOwner',
  Me: 'Me',
  me: 'me',
  More: 'More',
  'Raise hand': 'Raise hand',
  Agree: 'Agree',
  Chat: 'Chat',
  Cancel: 'Cancel',
  Exit: 'Exit full screen',
  'Full screen': 'Full screen',
  Members: 'Members',
  'Search Member': 'Search Member',
  'Transfer owner': 'Transfer owner',
  'Set as administrator': 'Set as administrator',
  'Revoke administrator': 'Revoke administrator',
  // @ts-ignore
  'The administrator status of sb has been withdrawn': ({ named }) => `The administrator status of ${named('name')} has been withdrawn`,
  // @ts-ignore
  'sb has been set as administrator': ({ named }) => `${named('name')} has been set as administrator`,
  'You have been invited by the administrator to step down, please raise your hand if you need to speak': 'You have been invited by the administrator to step down, please raise your hand if you need to speak',
  Invite: 'Invite',
  Settings: 'Settings',
  EndPC: 'End',
  EndH5: 'End',
  'You are currently the host of the room, please choose the corresponding operation. If you choose "End Room", the current room will be disbanded and all members will be removed. If you choose "Leave Room", the current room will not be disbanded, and your hosting privileges will be transferred to other members.': 'You are currently the host of the room, please choose the corresponding operation. If you choose "End Room", the current room will be disbanded and all members will be removed. If you choose "Leave Room", the current room will not be disbanded, and your hosting privileges will be transferred to other members.',
  'You are currently the host of the room, please choose the corresponding operation. If you choose "End Room", the current room will be disbanded and all members will be removed.': 'You are currently the host of the room, please choose the corresponding operation. If you choose "End Room", the current room will be disbanded and all members will be removed.',
  'If you do not want to end the meeting, please designate a new host before leaving the meeting.': 'If you do not want to end the meeting, please designate a new host before leaving the meeting.',
  'Are you sure you want to leave this room?': 'Are you sure you want to leave this room?',
  'New host': 'New host',
  'Transfer and leave': 'Transfer and leave',
  'Leave room?': 'Leave room?',
  'Select a new host': 'Select a new host',
  'Appoint a new host': 'Appoint a new host',
  'The host closed the room.': 'The host closed the room.',
  Note: 'Note',
  Confirm: 'Confirm',
  Leave: 'Leave',
  Dismiss: 'Dismiss',
  // @ts-ignore
  'The administrator has been changed to ': 'The administrator has been changed to ',
  'Muted by the moderator': 'Muted by the moderator',
  'Type a message': 'Type a message',
  Send: 'Send',
  'Failed to send the message': 'Failed to send the message',
  'Applying for the stage': 'Applying for the stage',
  'Apply for the stage': 'Apply for the stage',
  'Cancel Apply': 'Cancel Apply',
  'Are you sure you want to step down': 'Are you sure you want to step down',
  Check: 'Check',
  Neglect: 'Neglect',
  'Disable all audios': 'Disable all audios',
  'Enable all audios': 'Enable all audios',
  'Disable all videos': 'Disable all videos',
  'Enable all videos': 'Enable all videos',
  'Member List': 'Member List',
  'All mute': 'All mute',
  'All stop video': 'All stop video',
  'Lift all mute': 'Lift all mute',
  'Lift stop all video': 'Lift stop all video',
  Unmute: 'Unmute',
  'Cancel Unmute': 'Cancel Unmute',
  Mute: 'Mute',
  members: 'members',
  'Failed to get chat message': 'Failed to get chat message',
  'Agree to the stage': 'Agree to the stage',
  'Take the stage now': 'Take the stage now',
  'Stay off the stage': 'Stay off the stage',
  'Cancel stage': 'Cancel stage',
  'Invite stage': 'Invite stage',
  'Refuse stage': 'Refuse stage',
  'Members applying on stage': 'Members applying on stage',
  'Step down': 'Step down',
  'Step down(Master)': 'Step down',
  'Enable video': 'Enable video',
  'Disable video': 'Disable video',
  'Enable chat': 'Enable chat',
  'Disable chat': 'Disable chat',
  'Kick out': 'Kick out',
  'is sharing their screen': 'is sharing their screen',
  'Apply to stage': 'Apply to stage',
  'Apply to stage application': 'Apply to stage application',
  'Member Onstage Application': 'Member Onstage Application',
  Reject: 'Reject',
  'Reject All': 'Reject All',
  'Agree All': 'Agree All',
  'Please raise your hand to apply': 'Please raise your hand to apply',
  'You can turn on the microphone and camera once you are on stage': 'You can turn on the microphone and camera once you are on stage',
  // @ts-ignore
  'Sb invites you to speak on stage': ({ named }) => `${named('role')} invites you to speak on stage`,
  'After agreeing to go on stage, you can turn on the camera and microphone. Do you agree to go on stage?': 'After agreeing to go on stage, you can turn on the camera and microphone. Do you agree to go on stage?',
  'Hand down': 'Hand down',
  // @ts-ignore
  'sb has rejected your application for the stage': ({ named }) => `${named('role')} has rejected your application for the stage`,
  'You have been invited by the host to step down, please raise your hand if you need to speak': 'You have been invited by the host to step down, please raise your hand if you need to speak',
  'If you have any questions, please email us.': 'If you have any questions, please email us.',
  'Join our product discussion group': 'Join our product discussion group',
  'Our email address': 'Our email address',
  'Join now': 'Join now',
  'Select a screen/window': 'Select a screen/window',
  Screen: 'Screen',
  Window: 'Window',
  Share: 'Share',
  'Continue sharing': 'Continue sharing',
  'Select a screen or window first': 'Select a screen or window first',
  Grid: 'Grid',
  Tips: 'Tips',
  'Gallery on right': 'Gallery on right',
  'Gallery at top': 'Gallery at top',
  'Network ': 'Network ',
  Latency: 'Latency',
  Stability: 'Stability',
  Fluctuation: 'Fluctuation',
  Lag: 'Lag',
  Disconnected: 'Disconnected',
  'Packet loss': 'Packet loss',
  'Share the room ID or invite link': 'Share the room ID or invite link',
  'Invite by room number': 'Invite by room number',
  'Invite via room link': 'Invite via room link',
  'Room Link': 'Room Link',
  'You can share the room number or link to invite more people to join the room.': 'You can share the room number or link to invite more people to join the room.',
  'You can share the room number to invite more people to join the room': 'You can share the room number to invite more people to join the room',
  'If you have any questions, please feel free to join our QQ group or send an email': 'If you have any questions, please feel free to join our QQ group or send an email',
  'Room QR code': 'Room QR code',
  'Search for conference attendees': 'Search for conference attendees',
  'Invite via client scheme': 'Invite via client scheme',
  'All current and new members will be muted': 'All current and new members will be muted',
  'All and new members will be banned from the camera': 'All and new members will be banned from the camera',
  'No relevant user found.': 'No relevant user found.',
  'Contact us': 'Contact us',
  'Member management': 'Member management',
  'Join our QQ group chat or email us.': 'Join our QQ group chat or email us.',
  'group chat': 'group chat',
  Email: 'Email',
  'Audio settings': 'Audio settings',
  'Camera settings': 'Camera settings',
  Copy: 'Copy',
  'Copied successfully': 'Copied successfully',
  'accepted the invitation to the stage': 'accepted the invitation to the stage',
  'declined the invitation to the stage': 'declined the invitation to the stage',
  'All audios disabled': 'All audios disabled',
  'All audios enabled': 'All audios enabled',
  'Your microphone has been turned off': 'Your microphone has been turned off',
  // @ts-ignore
  'Sb invites you to turn on the microphone': ({ named }) => `${named('role')} invites you to turn on the microphone`,
  'All videos disabled': 'All videos disabled',
  'All videos enabled': 'All videos enabled',
  'Disabling text chat for all is enabled': 'Disabling text chat for all is enabled',
  'Unblocked all text chat': 'Unblocked all text chat',
  'Your camera has been turned off': 'Your camera has been turned off',
  // @ts-ignore
  'Sb invites you to turn on the camera': ({ named }) => `${named('role')} invites you to turn on the camera`,
  'The host has turned off your screen sharing': 'The host has turned off your screen sharing',
  'Turn on the camera': 'Turn on the camera',
  'Keep it closed': 'Keep it closed',
  'You have been banned from text chat': 'You have been banned from text chat',
  'You are allowed to text chat': 'You are allowed to text chat',
  'kicked out of the room by the host': 'kicked out of the room by the host',
  'kicked out of the room by other device': 'kicked out of the room by other device',
  'kicked out of the room by serve': 'kicked out of the room by serve',
  // @ts-ignore
  'Reject on Stage failed, please retry': ({ named }) => `Reject ${named('name')} on Stage failed, please retry`,
  // @ts-ignore
  'Agree on Stage failed, please retry': ({ named }) => `Agree ${named('name')} on Stage failed, please retry`,
  'Has been fully muted and cannot open the microphone': 'Has been fully muted and cannot open the microphone',
  'Has been muted by the host and cannot open the microphone': 'Has been muted by the host and cannot open the microphone',
  'To apply to speak in the room, please raise your hand first to apply for the microphone': 'To apply to speak in the room, please raise your hand first to apply for the microphone',
  'Has been full static painting, can not open the video': 'Has been full static painting, can not open the video',
  'It has been stilled by the host and cannot open the video': 'It has been stilled by the host and cannot open the video',
  'Failed to enter the room.': 'Failed to enter the room.',
  'Has been full static painting, can not share your screen': 'Has been full static painting, can not share your screen.',
  'Microphone not detected on current device': 'Microphone not detected on current device',
  'Camera not detected on current device': 'Camera not detected on current device',
  'Camera And Microphone not detected on current device': 'Camera And Microphone not detected on current device',
  'Another user is currently sharing the screen, screen sharing is not possible.': 'Another user is currently sharing the screen, screen sharing is not possible.',
  'This action causes the room to be disbanded, does it continue?': 'This action causes the room to be disbanded, does it continue?',
  'This action causes the room to be exited, does it continue?': 'This action causes the room to be exited, does it continue?',
  'Sharing screens may lead to the leakage of private information such as SMS verification codes and passwords, resulting in financial losses. Please be vigilant against various forms of fraud.': 'Sharing screens may lead to the leakage of private information such as SMS verification codes and passwords, resulting in financial losses. Please be vigilant against various forms of fraud.',
  'Please enter the room number': 'Please enter the room number',
  // @ts-ignore
  'whether to kick sb off the room': ({ named }) => `whether to kick ${named('name')} off the room`,
  'The current browser does not support capturing audio and video': 'The current browser does not support capturing audio and video',
  'The current browser does not support getting microphone and camera list': 'The current browser does not support getting audio/video device list',
  'The current browser does not support screen sharing': 'The current browser does not support screen sharing',
  'The current browser does not support capturing audio': 'The current browser does not support capture audio',
  'The current browser does not support capturing video': 'The current browser does not support capture video',
  'The current browser does not support audio and video communication capabilities': 'The current browser does not support audio and video communication capabilities',
  // @ts-ignore
  'An invitation to open the microphone has been sent to sb.': ({ named }) => `An invitation to open the microphone has been sent to ${named('name')}`,
  // @ts-ignore
  'An invitation to open the camera has been sent to sb.': ({ named }) => `An invitation to open the camera has been sent to ${named('name')}`,
  'Transfer owner failed, please try again.': 'Transfer owner failed, please try again.',
  // @ts-ignore
  'Sb has been set as an administrator': ({ named }) => `${named('name')} has been set as an administrator.`,
  'Succeed on stage': 'Succeed on stage',
  'After unlocking, users can freely turn on the microphone': 'After unlocking, users can freely turn on the microphone',
  'Members will not be able to open the microphone': 'Members will not be able to open the microphone',
  'After unlocking, users can freely turn on the camera': 'After unlocking, users can freely turn on the camera',
  'Members will not be able to open the camera': 'Members will not be able to open the camera',
  'You have become a administrator': 'You have become a administrator',
  'You are now a room owner': 'You are now a room owner',
  'Your administrator status has been revoked': 'Your administrator status has been revoked',
  'After transfer the room owner, you will become a general user': 'After transfer the room owner, you will become a general user',
  // @ts-ignore
  'Transfer the roomOwner to sb': ({ named }) => `Transfer the roomOwner to ${named('name')}`,
  'Confirm transfer': 'Confirm transfer',
  // @ts-ignore
  'The room owner has been transferred to sb': ({ named }) => `The room owner has been transferred to ${named('name')}`,
  'Application to go on stage was rejected': 'Application to go on stage was rejected',
  'You are now an administrator': 'You are now an administrator',
  'The RoomOwner has withdrawn your administrator privileges': 'The RoomOwner has withdrawn your administrator privileges',
  'This member has already received the same request, please try again later': 'This member has already received the same request, please try again later',
  'Failed to go on stage, invitation has timed out': 'Failed to go on stage, invitation has timed out',
  'The current number of people on stage has reached the limit': 'The current number of people on stage has reached the limit',
  // @ts-ignore
  'The invitation to sb to go on stage has timed out': ({ named }) => `The invitation to ${named('name')} to go on stage has timed out`,
  'Currently no member has applied to go on stage': 'Currently no member has applied to go on stage',
  Operate: 'Operate',
  'Stage management': 'Stage management',
  'Already on stage': 'Already on stage',
  'Not on stage': 'Not on stage',
  'To go on stage again, you need to reapply and wait for the roomOwner/administrator to approve': 'To go on stage again, you need to reapply and wait for the roomOwner/administrator to approve',
  'To go on stage again, a new application needs to be initiated': 'To go on stage again, a new application needs to be initiated',
  'The request to go on stage has been sent out, please wait for the roomOwner/administrator to approve it': 'The request to go on stage has been sent out, please wait for the roomOwner/administrator to approve it',
  'Cancellation request has been sent, please wait for the roomOwner/administrator to approve it': 'Cancellation request has been sent, please wait for the roomOwner/administrator to approve it',
  'Canceled application to go on stage': 'Canceled application to go on stage',
  'and so on': 'and so on',
  'people applying to stage': 'people applying to stage',
  // @ts-ignore
  'and so on number people applying to stage': ({ named }) => `and so on ${named('number')} people applying to stage`,
  // Room Chat 融合卡片翻译
  'quick meeting': 'quick meeting',
  Meeting: 'Meeting',
  'Meeting in progress': 'Meeting in progress',
  Initiating: 'Initiating',
  'X people have joined': ({ values }: any) => `${values?.number} people have joined`,
  'Waiting for members to join the meeting': 'Waiting for members to join the meeting',
  'X people are in the meeting': ({ values }: any) => `${values?.number} people are in the meeting`,
  'Already joined': 'Already joined',
  'Enter the meeting': 'Enter the meeting',
  'Ending meeting': 'Ending meeting',
  'The meeting has ended': 'The meeting has ended',
  'Currently in a meeting, please exit the current meeting before proceeding.': 'Currently in a meeting, please exit the current meeting before proceeding.',
  'Failed to initiate meeting': 'Failed to initiate meeting',
  'Failed to enter the meeting': 'Failed to enter the meeting',
};
